import { useRef, useState } from "react";
import { ChevronsLeftRight } from "lucide-react";

export default function BeforeAfter({ beforeSrc, afterSrc }) {
  const ref = useRef(null);
  const dragging = useRef(false);
  const [pos, setPos] = useState(50);

  const update = (clientX) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.min(96, Math.max(4, p)));
  };

  const onPointerDown = (e) => {
    dragging.current = true;
    e.currentTarget.setPointerCapture?.(e.pointerId);
    update(e.clientX);
  };
  const onPointerMove = (e) => {
    if (dragging.current) update(e.clientX);
  };
  const stop = () => {
    dragging.current = false;
  };

  return (
    <div
      ref={ref}
      data-testid="before-after-slider"
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={stop}
      onPointerLeave={stop}
      className="relative h-[300px] sm:h-[440px] lg:h-[540px] w-full cursor-ew-resize overflow-hidden rounded-2xl border border-white/10 select-none shadow-[0_24px_70px_rgba(0,10,30,0.65)]"
      style={{ touchAction: "pan-y" }}
    >
      <img
        src={afterSrc}
        alt="Terreno após a terraplenagem"
        draggable={false}
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img
          src={beforeSrc}
          alt="Terreno antes da terraplenagem"
          draggable={false}
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-[#050b14]/25" />
      </div>

      <span className="absolute top-4 left-4 rounded-full glass px-4 py-1.5 font-mono text-[10px] tracking-[0.3em] text-white">
        ANTES
      </span>
      <span className="absolute top-4 right-4 rounded-full bg-dm-blue px-4 py-1.5 font-mono text-[10px] tracking-[0.3em] text-white">
        DEPOIS
      </span>

      <div className="absolute inset-y-0 w-0" style={{ left: `${pos}%` }}>
        <div className="absolute inset-y-0 left-0 w-[2px] -translate-x-1/2 bg-white/90 shadow-[0_0_16px_rgba(0,240,255,0.8)]" />
        <div
          data-testid="before-after-handle"
          className="absolute top-1/2 left-0 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white text-[#050b14] shadow-[0_0_24px_rgba(0,240,255,0.5)]"
        >
          <ChevronsLeftRight size={20} />
        </div>
      </div>

      <p className="absolute bottom-4 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full glass px-4 py-1.5 font-mono text-[9px] tracking-[0.25em] text-slate-300">
        TERRAPLENAGEM — CORTE E ATERRO
      </p>
    </div>
  );
}
